const Logout = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3.676 10.077h12.472a1.077 1.077 0 0 0 0-2.153H3.676l1.391-1.392A1.077 1.077 0 1 0 3.545 5.01L.315 8.24a1.058 1.058 0 0 0-.07.077l-.016.021c-.016.02-.032.042-.047.064l-.012.02c-.015.023-.03.046-.043.07l-.007.015a1.073 1.073 0 0 0-.038.08l-.003.011a1.062 1.062 0 0 0-.032.089l-.003.011a1.05 1.05 0 0 0-.023.09l-.004.028a1.007 1.007 0 0 0-.012.292l.012.078.004.026c.006.031.014.062.023.091l.003.011c.009.03.02.06.032.09l.003.01c.012.027.025.054.039.08l.006.015c.014.024.028.048.043.07l.012.02c.015.022.03.043.047.064l.016.02c.022.028.046.054.07.079l3.23 3.23a1.073 1.073 0 0 0 1.522 0c.42-.421.42-1.103 0-1.523l-1.391-1.392Z" fill="currentColor"/>
      <path d="M14.878.194a8.8 8.8 0 0 0-7.314 3.9 1.077 1.077 0 0 0 1.787 1.2 6.65 6.65 0 0 1 5.527-2.947 6.66 6.66 0 0 1 6.653 6.654 6.652 6.652 0 0 1-12.17 3.72 1.077 1.077 0 0 0-1.785 1.204 8.802 8.802 0 0 0 7.302 3.882c4.856 0 8.806-3.95 8.806-8.806 0-4.856-3.95-8.807-8.806-8.807Z" fill="currentColor"/>
    </svg>
  )
}

export default Logout
